const CancelablePromise = require('mn-utils/CancelablePromise');
const getTime = require('mn-utils/time');
const dynamicModule = require('mn-utils/browser/dynamicModule');
const dynamic = require('mn-utils/browser/dynamic');
const downloadBase = require('mn-utils/browser/download').base;
const getBase64Image = require('mn-utils/browser/getBase64Image');
const repeat = require('mn-utils/repeat');

import React from 'react';
import ReactPDF from '@react-pdf/renderer';


// const modulePdfMake = module.exports = dynamicModule((options) => {
//   return dynamic('./pdfMake.js', {
//     query: {
//       t: +new Date(),
//     },
//   }).then(() => {
//     return window.pdfMake;
//   });
// });
//
//
// modulePdfMake.exportPDF = exportPDF;
// modulePdfMake.makePDF = makePDF;
//
// const MAKE_PDF_OPTIONS = modulePdfMake.MAKE_PDF_OPTIONS = {
//   getBase64Image,
//   getLunuLogo,
//   exportPDF,
//   exportLunuPDF,
//   line(name, value) {
//     return {
//       margin: [0, 0, 0, 15],
//       columns: [
//         {
//           width: 90,
//           text: name,
//           fontSize: 8,
//         },
//         {
//           width: 150,
//           text: value,
//           fontSize: 8,
//         },
//       ],
//     };
//   },
// };
//
// function getLunuLogo() {
//   return getBase64Image('./lunu.png');
// }
// function getHeader() {
//   return getBase64Image('./pdfGeneration/kyc-pdf-heading.jpg');
// }
// function getDotBg() {
//   return getBase64Image('./pdfGeneration/kyc-pdf-point-bg.png');
// }
// function blockTitle(index, title, dotBgUrl) {
//   return {
//     columns: [
//       {
//         text: `\t${index}\t`,
//         width: 60,
//         height: 60,
//         // margin: [20, 14, 20, 14],
//         fontSize: 24,
//         color: '#FFF',
//         bold: true,
//         background: {
//           image: dotBgUrl,
//           width: 5,
//           height: 5,
//           absolutePosition: { x: 150, y: 250 }
//         }
//       },
//       {
//         text: title,
//         margin: [22, 0, 0, 0],
//         fontSize: 46,
//         bold: true
//       },
//     ],
//     margin: [0, 105, 0, 0]
//   }
// };
//
// async function exportLunuPDF(content) {
//   const headerUrl = await getHeader();
//   const dotBgUrl = await getDotBg();
//   return exportPDF({
//     params: {
//       pageSize: {
//         width: 2480,
//         height: 3508
//       },
//       pageMargins: [191, 300, 0, 191],
//       header: function(currentPage, pageCount, pageSize) {
//         // you can apply any logic and return any valid pdfmake element
//
//         return [
//           { image: headerUrl, margin: [191, 191, 0, 191] }
//         ]
//       },
//       content: [
//         blockTitle(1, 'COMPANY', dotBgUrl),
//         {
//           // columns: [
//           //   // {
//           //   //   image: dataUrl
//           //   // },
//           //   {
//           //     width: '100%',
//           //     text: 'KYC'
//           //   }
//           // ],
//           // style: 'header'
//           // columns: [
//           //   {
//           //     image: dataUrl,
//           //     width: 80,
//           //     margin: [0, 0, 0, 35],
//           //   },
//           //   {
//           //     text: 'KYC'
//           //   }
//           // ]
//
//         },
//         // {
//         //   image: dataUrl,
//         //   width: 80,
//         //   margin: [0, 0, 0, 35],
//         // },
//         // separator(),
//         // ...content,
//       ],
//       styles: {
//         header: {
//           fontSize: 42,
//           // background: '#000000',
//           // color: '#FFFFFF',
//           // bold: true
//         },
//         anotherStyle: {
//           italics: true,
//           alignment: 'right'
//         }
//       }
//     },
//   });
// }
// function makePDF(callback) {
//   return CancelablePromise.resolve(callback(MAKE_PDF_OPTIONS));
// }

const MyDocument = () => {
  return (
    <span />
  )
}


module.exports = function exportPDF(options) {
  console.log('-------------', ReactPDF.renderToStream(<MyDocument />));
  // return modulePdfMake().then((pdfMake) => {
  //   return new CancelablePromise((resolve, reject) => {
  //     let _stop;
  //     pdfMake.createPdf(options.params).getBlob((blob) => {
  //       _stop || resolve(downloadBase(
  //           URL.createObjectURL(blob),
  //           options.downloadFileName || `${getTime()}.pdf`,
  //       ));
  //     });
  //     return () => {
  //       _stop = 1;
  //     };
  //   });
  // });
}
